module.exports = __webpack_public_path__ + "media/images/talent/mv-05-ea1b19521c633f2a0f5bcf4e564b2c10.png";